import { useEffect, useState } from 'react';

import {
  Box,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { GetAllOrganizationList } from '../../../network/Organization';
import { UpdateDeviceToOrganization } from '../../../network/Devices';

// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: { xs: '70%', md: '40%' },
  maxWidth: { xs: '70%', md: '40%' },
  minHeight: '40vh',
  bgcolor: 'background.paper',
  p: 2,
  borderRadius: 1,
  display: 'flex',
  flexDirection: 'column'
};
const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function AssignOrganizationModal({
  openAssignedModal,
  handleClose,
  deviceDetail,
  setAlertMetas,
  alertMetas
}) {
  const classes = useStyles();
  const deviceImei = deviceDetail?.device_settings?.imei || '';
  const [organizationList, setOrganizationList] = useState([]);
  const [organizationId, setOrganizationId] = useState('');
  const [loader, setLoader] = useState(false);

  const getAllOrganization = async () => {
    try {
      const res = await GetAllOrganizationList();
      if (res) {
        setOrganizationList(res.data.data);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const UpdateDeviceOrganization = async () => {
    const payload = {
      organizationId,
      deviceIds: [deviceImei]
    };
    setLoader(true);

    try {
      const response = await UpdateDeviceToOrganization(payload);

      if (response?.data?.data?.updatedDevices?.length === 0) {
        setAlertMetas({
          ...alertMetas,
          severity: 'error',
          snackBarOpened: true,
          msg: response?.data?.data?.message
        });
      } else {
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: response?.data?.data?.message
        });
      }

      setTimeout(() => {
        setAlertMetas((prevState) => ({
          ...prevState,
          snackBarOpened: false,
          msg: ''
        }));
      }, 4000);
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => {
        setAlertMetas((prevState) => ({
          ...prevState,
          snackBarOpened: false,
          msg: ''
        }));
      }, 4000);
    } finally {
      handleClose();
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllOrganization();
  }, []);

  return (
    <Box>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="organization-update-modal"
      >
        <Box sx={style}>
          <Typography
            sx={{ fontSize: { xs: 14, sm: 18 }, fontWeight: { xs: 700, sm: 900 }, mb: 2 }}
          >
            Assign Devices to Organization
          </Typography>
          <FormControl fullWidth>
            <InputLabel
              id="organization-select-label"
              sx={{ fontSize: { xs: '12px', sm: '14px' } }}
            >
              Select Organization *
            </InputLabel>
            <Select
              size="large"
              labelId="organization-select-label"
              id="organization-select-label"
              label="Select Organization *"
              sx={{
                fontSize: { xs: '12px', sm: '14px' },
                '& .MuiOutlinedInput-input': {
                  padding: { xs: '14px 8px', sm: '16.5px 14px' }
                }
              }}
              IconComponent={ExpandMoreIcon}
              value={organizationId}
              onChange={(e) => setOrganizationId(e.target.value)}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 150,
                    overflowY: 'auto'
                  }
                }
              }}
            >
              {organizationList?.map((item) => (
                <MenuItem
                  value={item?.id}
                  key={item?.id}
                  className={classes.menuItem}
                  sx={{
                    textTransform: 'capitalize'
                  }}
                >
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ textAlign: 'right', width: '100%', mt: 'auto' }}>
            <Button type="button" variant="outlined" sx={{ mr: 2 }} onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loader}
              onClick={UpdateDeviceOrganization}
            >
              Assign
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
